// Must match HeaderViewModelBuilder.PreviousRetailerCookieName
export const PREVIOUS_RETAILER_COOKIE = 'lastRetailer';
export const PREVIOUS_RETAILER_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90;
